module.exports = __webpack_public_path__ + "98a95bd75bbac2666defa2d26c5f3b0e.pdf";